import { createSlice } from '@reduxjs/toolkit';

export const LinksEncuestasSlice = createSlice({
    name: 'links_encuestas',
    initialState: {
        links_encuestas_list: [],
        links_encuestas_detail: {},
        links_surveys_for_select: [],
        links_users_for_select: [],
        links_share_templates_for_select: []
    },
    reducers: {
        setLinksEncuestasRedux: (state, { payload }) => {
            state.links_encuestas_list = payload;
        },
        storeLinkEncuestaDetailRedux: (state, { payload }) => {
            state.links_encuestas_detail = payload;
        },
        setLinksSurveysForSelect: (state, { payload }) => {
            state.links_surveys_for_select = payload;
        },
        setLinksUsersForSelect: (state, { payload }) => {
            state.links_users_for_select = payload;
        },
        setLinksShareTemplatesForSelect: (state, { payload }) => {
            state.links_share_templates_for_select = payload;
        }
    }
});

export const { 
    setLinksEncuestasRedux, 
    storeLinkEncuestaDetailRedux,
    setLinksSurveysForSelect,
    setLinksUsersForSelect,
    setLinksShareTemplatesForSelect
} = LinksEncuestasSlice.actions;
